import React from 'react'
import { DropZoneContainer } from './DropZone.styles'

interface DropZoneProps {
	isExpanded?: boolean
}

const DropZone: React.FC<DropZoneProps> = ({ isExpanded = false }) => {
	return <DropZoneContainer $isExpanded={isExpanded}>{isExpanded ? 'Drop Here' : ''}</DropZoneContainer>
}

export default DropZone
